import { render, staticRenderFns } from "./MeetHeadNew.vue?vue&type=template&id=22800b2c&scoped=true"
import script from "./MeetHeadNew.vue?vue&type=script&lang=js"
export * from "./MeetHeadNew.vue?vue&type=script&lang=js"
import style0 from "./MeetHeadNew.vue?vue&type=style&index=0&id=22800b2c&prod&lang=scss&scoped=true"
import style1 from "./MeetHeadNew.vue?vue&type=style&index=1&id=22800b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22800b2c",
  null
  
)

export default component.exports